import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["type"]
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["type"]
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["type"]
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_10 = ["disabled"]

import { reactive, watch } from 'vue'
import { Eye, EyeOff } from 'lucide-vue-next'
import Modal from '@/components/layout/Modal.vue'

import { ref } from 'vue'

interface PasswordForm {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePasswordModal',
  props: {
    isOpen: { type: Boolean },
    passwordForm: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localForm = reactive<PasswordForm>({ ...props.passwordForm })
const showCurrent = ref(false)
const showNew = ref(false)
const showConfirm = ref(false)

watch(() => props.passwordForm, (val) => {
  Object.assign(localForm, val)
}, { deep: true })

const handleSave = () => {
  emit('save', { ...localForm })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "model-value": __props.isOpen,
    title: "Change Password",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 px-4 py-2 text-sm font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-primary to-secondary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60",
        disabled: __props.loading,
        onClick: handleSave
      }, " Update Password ", 8, _hoisted_10)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Current Password", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: showCurrent.value ? 'text' : 'password',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localForm.currentPassword) = $event)),
              class: "w-full rounded-xl px-4 py-3 pr-10 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
            }, null, 8, _hoisted_4), [
              [_vModelDynamic, localForm.currentPassword]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showCurrent.value = !showCurrent.value))
            }, [
              (!showCurrent.value)
                ? (_openBlock(), _createBlock(_unref(EyeOff), {
                    key: 0,
                    class: "h-4 w-4"
                  }))
                : (_openBlock(), _createBlock(_unref(Eye), {
                    key: 1,
                    class: "h-4 w-4"
                  }))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "New Password", -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: showNew.value ? 'text' : 'password',
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localForm.newPassword) = $event)),
              class: "w-full rounded-xl px-4 py-3 pr-10 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
            }, null, 8, _hoisted_6), [
              [_vModelDynamic, localForm.newPassword]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showNew.value = !showNew.value))
            }, [
              (!showNew.value)
                ? (_openBlock(), _createBlock(_unref(EyeOff), {
                    key: 0,
                    class: "h-4 w-4"
                  }))
                : (_openBlock(), _createBlock(_unref(Eye), {
                    key: 1,
                    class: "h-4 w-4"
                  }))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300" }, "Confirm New Password", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: showConfirm.value ? 'text' : 'password',
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localForm.confirmPassword) = $event)),
              class: "w-full rounded-xl px-4 py-3 pr-10 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
            }, null, 8, _hoisted_8), [
              [_vModelDynamic, localForm.confirmPassword]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirm.value = !showConfirm.value))
            }, [
              (!showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(EyeOff), {
                    key: 0,
                    class: "h-4 w-4"
                  }))
                : (_openBlock(), _createBlock(_unref(Eye), {
                    key: 1,
                    class: "h-4 w-4"
                  }))
            ])
          ]),
          (localForm.newPassword && localForm.confirmPassword && localForm.newPassword !== localForm.confirmPassword)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Passwords do not match"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})